import * as React from 'react';
import { headingSectionIndexContext } from './context';
export function useHeadingSectionIndex() {
    var headingSectionIndex = React.useContext(headingSectionIndexContext);
    return headingSectionIndex;
}
